<template>
  <v-container
    fluid
  >
    <v-form>
      <v-container>
        <v-btn
          class="ma-2 float-left"
          tile
          outlined
          :loading="btnLoading"
          :disabled="btnLoading"
          color="success"
          @click="save()"
        >
          <v-icon
            left
          >
            mdi-check
          </v-icon>
          {{ $t('save') }}
        </v-btn>
        <v-subheader
          class="display-1"
        >
          {{ $t('operations_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="FormsCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template
                  v-slot:append
                >
                  <v-text-field
                    v-model="FormsCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="formsValue"
                :items="formsItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-subheader
          class="display-1"
        >
          {{ $t('results_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="FormsResultsCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template
                  v-slot:append
                >
                  <v-text-field
                    v-model="FormsResultsCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="formsResultsValue"
                :items="formsResultsItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    name: 'Settings',
    data: () => ({
      btnLoading: false,
      valid: false,
      FormsCPP: 0,
      FormsResultsCPP: 0,
      min: 1,
      max: 100,
      formsItems: [],
      formsValue: [],
      formsResultsItems: [],
      formsResultsValue: [],
      dynamicColumns: [],
      snackbar: false,
      snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
      snackbarText: '',
    }),
    async created () {
      await this.getOptions()
      await this.getFormsColumns()
      await this.getFormsResultsColumns()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showLikeTitle', {
          title: 'Forms',
        }).then(
          response => {
            const result = response.data.Option
            this.FormsCPP = parseInt(result.find(x => x.title === 'Forms-CPP').value)
            this.FormsResultsCPP = parseInt(result.find(x => x.title === 'Forms-Results-CPP').value)
            let tempValue = result.filter(x => x.title === 'Forms-TH-Operations')
            let tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.formsValue = tempArray

            tempValue = result.filter(x => x.title === 'Forms-TH-Results')
            tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.formsResultsValue = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/showLikeTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showLikeTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getFormsColumns () {
        this.$http.post('forms/columns').then(
          response => {
            const result = response.data.FormsColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({
                dbitem: value,
                display: self.$t(value),
              })
            })
            this.formsItems = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': forms/columns|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': forms/columns|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getFormsResultsColumns () {
        this.$http.post('forms/columnsResults').then(
          response => {
            console.log(response.data)
            const result = response.data.FormResultsColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({ dbitem: value, display: self.$t(value) })
            })
            this.formsResultsItems = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': FormResultsColumns/columns|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': FormResultsColumns/columns|902'
          this.snackbar = true
          console.log(error)
        })
      },
      save () {
        this.btnLoading = true
        const temparray = []
        this.formsValue.forEach(o => {
          temparray.push({ title: 'Forms-TH-Operations', value: o, language_id: 1 })
        })
        this.formsResultsValue.forEach(o => {
          temparray.push({ title: 'Forms-TH-Results', value: o, language_id: 1 })
        })
        this.$http.post('options/destroyAndInsertByTitle', {
          title: ['Forms-TH-Operations', 'Forms-TH-Results'],
          insertArray: temparray,
        }).then(
          response => {
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_updated')
            this.snackbar = true
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/destroyAndInsertByTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/destroyAndInsertByTitle|902'
          this.snackbar = true
          console.log(error)
        })
        this.btnLoading = false
      },
    },
  }
</script>

<style scoped>

</style>
